import jwt from 'jwt-decode'
import { clearStore } from '../components/utils/StoreUtils'
export const actionTypes = {
  login: 'LOGIN',
  logout: 'LOGOUT',
  locale: 'LOCALE',
  change: 'CHANGE',
  changeFirstAccess: 'CHANGEFIRSTACCESS',
}

const loginSuccess = ({ email, accessToken, iduser, name, dashboard, type = actionTypes.login, firstAccess }) => {
  const roles = jwt(accessToken) ? jwt(accessToken).authorities : []
  const signUpAt = jwt(accessToken) && jwt(accessToken).iat ? jwt(accessToken).iat : undefined
  const rolesPermitted =
    jwt(accessToken) && jwt(accessToken).rolesPermitted ? jwt(accessToken).rolesPermitted : undefined
  const locale = 'es_ES'
  return {
    type: type,
    payload: {
      email,
      iduser,
      name,
      dashboard,
      roles,
      rolesPermitted,
      signUpAt,
      locale,
      firstAccess,
    },
  }
}

const login = (data) => {
  return loginSuccess(data)
}

const change = (response) => {
  return loginSuccess({
    email: response.data.email,
    accessToken: response.data.accessToken,
    iduser: response.data.iduser,
    name: response.data.name,
    dashboard: response.data.dashboard,
    firstAccess: response.data.firstAccess,
    type: actionTypes.change,
  })
}
const logout = () => {
  clearStore()
  return { type: actionTypes.logout }
}

const local = (locale) => {
  return { type: actionTypes.locale, payload: locale }
}

const changeFirstAccess = (firstAccess) => {
  return { type: actionTypes.changeFirstAccess, payload: firstAccess }
}

export const actions = {
  login,
  logout,
  local,
  change,
  changeFirstAccess,
}
